var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 2.91015 2.91015 0 6.5 0C10.0899 0 13 2.91015 13 6.5V11.1429C13 12.1685 12.1685 13 11.1429 13H6.5C2.91015 13 0 10.0899 0 6.5Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15945 6.84446C6.44136 6.33557 6.9832 6.03536 7.29805 5.58504C7.63121 5.11276 7.4445 4.23044 6.49994 4.23044C5.88121 4.23044 5.57734 4.69906 5.4492 5.08714L4.50098 4.68808C4.76091 3.90826 5.46751 3.23828 6.49627 3.23828C7.35663 3.23828 7.94607 3.63002 8.24628 4.12061C8.50256 4.54163 8.65266 5.32877 8.25726 5.91454C7.81793 6.56256 7.3969 6.76026 7.16992 7.17762C7.07839 7.34603 7.04178 7.45587 7.04178 7.99771H5.98372C5.98006 7.71214 5.93613 7.24718 6.15945 6.84446ZM7.23215 9.46215C7.23215 9.86487 6.90266 10.1944 6.49994 10.1944C6.09721 10.1944 5.76772 9.86487 5.76772 9.46215C5.76772 9.05943 6.09721 8.72993 6.49994 8.72993C6.90266 8.72993 7.23215 9.05943 7.23215 9.46215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.2d87315b97c8e5233de21674a4a36b4e.svg";
export { ForwardRef as ReactComponent };